import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActiveAdvertisementRequestModel,
  ActiveAdvertisementResponseModel,
  DeleteAdvertisementRequestModel,
  DeleteAdvertisementResponseModel,
  GetAdvertisementRequestModel,
  GetAdvertisementResponseModel,
  InactiveAdvertisementRequestModel,
  InactiveAdvertisementResponseModel,
  ListAdvertisementRequestModel,
  ListAdvertisementResponseModel,
  SaveAdvertisementRequestModel,
  SaveAdvertisementResponseModel,
} from 'models/setting/advertisement/advertisement.model';

export function getAdvertisement(payload: GetAdvertisementRequestModel) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetAdvertisementResponseModel,
      GetAdvertisementResponseModel
    >(`${PREFIX_API.GENERAL}/media-ads/${payload?.id}`);
  }
}

export function listAdvertisement(payload: ListAdvertisementRequestModel) {
  return authorizedRequest.get<
    ListAdvertisementResponseModel,
    ListAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads?${preprocessGetQuery(payload)}`);
}

export function createAdvertisement(payload: SaveAdvertisementRequestModel) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SaveAdvertisementResponseModel,
    SaveAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateAdvertisement(payload: SaveAdvertisementRequestModel) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.put<
    SaveAdvertisementResponseModel,
    SaveAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads/${payload?.id}`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteAdvertisement(payload: DeleteAdvertisementRequestModel) {
  return authorizedRequest.delete<
    DeleteAdvertisementResponseModel,
    DeleteAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads/${payload?.id}`);
}

export function inactiveAdvertisement(
  payload: InactiveAdvertisementRequestModel,
) {
  return authorizedRequest.put<
    InactiveAdvertisementResponseModel,
    InactiveAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads/${payload?.id}/inactive`);
}

export function activeAdvertisement(payload: ActiveAdvertisementRequestModel) {
  return authorizedRequest.put<
    ActiveAdvertisementResponseModel,
    ActiveAdvertisementResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads/${payload?.id}/active`);
}
